angular.module('impactx.fileselect').directive('ixFileDrop', function () {
    return {
        restrict: 'A',
        scope: {
            dropFunction: '&'
        },
        link: function (scope, element) {
            var dragCounter = 0;

            element.bind('drop', function (event) {
                dragCounter = 0;
                var file = event.originalEvent.dataTransfer.files[0], reader = new FileReader();
                reader.readAsDataURL(file);
                angular.element(".hover-mask").remove();

                scope.dropFunction({event: event.originalEvent, file: file});
                return false;
            });

            element.on('dragover', function(event) {
                event.originalEvent.dataTransfer.dropEffect = "copy";
                event.preventDefault();
            });

            element.bind('dragenter', function (event) {
                dragCounter++;

                if(dragCounter === 1) {
                    element.append('<div class="hover-mask"></div>');
                }
                event.originalEvent.dataTransfer.dropEffect = "copy";
                event.preventDefault();
            });

            element.bind('dragleave', function (event) {
                dragCounter--;
                if(dragCounter <= 0) {
                    angular.element(".hover-mask").remove();
                }
                event.originalEvent.dataTransfer.dropEffect = "none";
                event.preventDefault();
            });

            element.on('dragend', function(e) {
                angular.element(".hover-mask").remove();
                e.originalEvent.dataTransfer.dropEffect = "none";
                e.preventDefault();
                dragCounter = 0;
            });
        }
    }
});